import { CircularProgress, Grid, Stack, Typography } from '@mui/material';
import React from 'react';

const LoadingSpinner = () => {
    return (
        <Grid item>
            <Typography variant="h6">
                <Stack direction="row" spacing={2} alignItems="center">
                    <CircularProgress
                        sx={{
                            '--CircularProgress-size': '60px',
                        }}
                    />
                    <Typography variant="h6">Adatok betöltése...</Typography>
                </Stack>
            </Typography>
        </Grid>
    )
}

export default LoadingSpinner;